import React, { useEffect } from "react";

import PublicLayout from "web/components/PublicLayout";

import LandingFooter from "web/pages/public/landing-page/LandingFooter";
// import Banner from "web/assets/images/fuunders-circle-banner.webp";
import FeaturedImage from "web/assets/images/PalletTrader_FC Member Portraits_Mortimer .webp";
// import FeaturedImage from "web/assets/images/Bettway-Image_cropped.webp";
import AmbassadorsSeal from "web/assets/images/palletTrader-ambassador-seal.webp";

import {
  Container,
  Wrapper,
  TextSection,
  Text,
  SubText,
} from "web/pages/public/landing-page/FoundersCircle/FounderCircleStyled";

const FeaturedAmbassador = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <PublicLayout transparentHeader={true}>
      <Container>
        <Wrapper>
          <TextSection>
            <Text className="text-center">
              <h3 className="featured-ambassador-heading">
                <span>The Founders Circle</span> Featured Ambassador
              </h3>
              {/* <h4>
                Our trusted partners, they make us better. They'll make you
                better, too.
              </h4>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero
              </p> */}
              <img className="banner" src={FeaturedImage} alt="featured-image" />
              <p className="featured-ambassador-sub-heading">
                {/* Fricks Pallet Company – PalletTrader profile for Pallet Enterprise */}
                Mortimer Pallet – PalletTrader Founder’s Circle – Member Profile
              </p>
            </Text>
            <SubText>
              <img className="ambassadors-seal" src={AmbassadorsSeal} alt="ambassadors seal" />
         <p style={{textAlign:"justify"}}>
         In his 25 years in the industry, Don Mortimer has seen the pallet industry grow and become increasingly sophisticated in the ways it responds to customer demands, manages resource use and recovery, employs new manufacturing techniques, equipment and processes, and more recently, addresses sustainability concerns.
         </p>
         <p style={{textAlign:"justify"}}>
         One area in which he has seen little change – how pallets are bought and sold.  “It’s pretty much been phone, fax or email, and a lot of face-to-face customer calls,” he notes. Not that such traditional methods are necessarily bad, it is just that “some technology developments that are common in other industries and markets, seemed to have bypassed pallets,” he notes. 
         </p>
         <p style={{textAlign:"justify"}}>
         Smithfield, Utah-based Mortimer Pallets is concentrated in Utah but also serves clients in Idaho, Montana and Wyoming. And while his local market, at about 150,000 in population, is equivalent to a mid-size American city, he competes with five other pallet yards for business. Most of Mortimer’s customers are a minimum of 90 miles away from his manufacturing site; most also have been with him for years. “Any leg up we can get we will take,” he remarks. 

         </p>
         <p style={{textAlign:"justify"}}>
         Finding that leg up was one reason he signed on with PalletTrader, he notes. A key factor: his relationship with Bettaway, with whom he has done business for over 20 years. “We have a longstanding relationship,” Moritmer notes. “I was more comfortable going into this new venture with someone I knew and trusted, who knows the business, and was respected.” 
         </p>
         <p style={{textAlign:"justify"}}>
         He believes PalletTrader will “change the time frame from demand to supply. It will shorten it, accelerate transactions, provide opportunities for more sales, in a cost-effective way without putting more feet on the ground, and streamline the transaction and settlement process. That’s good for the industry,” he notes. He adds that in his view the platform as built provides two important benefits: pallet suppliers, will get paid faster and will have more money to invest in capacity, and they’ll gain more visibility of their inventory to a wider potential customer audience. 
         </p>
         <p style={{textAlign:"justify"}}>
         Larger volume pallet buyers will still want special treatment – and special terms, he says. “We have a major customer that is buying 75k pallets a year from us, and their payment terms are 120 days. That’s a lot of float.  But if we didn’t agree to those terms, they are such a large buyer, they’d find someone else who would. If that’s providing a million dollars a year into a small community business, you’ll make that work.”
         </p>
         <p style={{textAlign:"justify"}}>
         Where he sees PalletTrader having particular advantage is with the small to mid-sized pallet depot – and their customers -- in a more concentrated metro area. “For the smaller pallet buyer, someone who wants a hundred pallets a load, or a load once a week, PalletTrader will turn the table on any buyer who wants to drag out that payment. It will provide more competition for that buyer to source pallets,” he notes. 

         </p>
         <p style={{textAlign:"justify"}}>
         The most significant change PalletTrader is bringing to the market? “It provides a simple, easy to use and easy to access place to find supply.  I pretty much sell what I produce, I don’t have a lot of lagging inventory,” he explains. “But for an operator who does, in a more concentrated metro market whose customers were within 20 miles or so, I’d be using PalletTrader daily to find cores to buy or customers to sell to. That market access and instant visibility is where the platform really delivers.  If I were to lose some of my current customer base, I would turn to PalletTrader to try and rebuild that.”
         </p>
         <p style={{textAlign:"justify"}}>
         He also believes pallets have suffered both as a misunderstood and disrespected element of the supply chain – and that PalletTrader is helping to change that. “I think it brings [recognition and understanding] of pallet companies up to par with a traditional business.  A lot of people, particularly those out of the industry, don’t look at this as a real business,” he’s observed.
         </p>
         <p style={{textAlign:"justify"}}>
         “When I first started, I’d tell people I’m in the pallet business, and their first question would be what’s that? The more enabling technology we have the more exposure and recognition we get as a market and a critical industry to shippers, and that will improve the reputation and understanding of pallets as a business.” 
         </p>
         <p style={{textAlign:"justify"}}>
         “At the end of the day, every other business that ships stuff can’t run without my business,” he says.
         </p>
            
            </SubText>
          </TextSection>
        </Wrapper>
      </Container>
      <LandingFooter />
    </PublicLayout>
  );
};

export default FeaturedAmbassador;
